<template>
  <div class="row justify-content-center">
    <div class="col-12 col-md-11 col-sm-12 col-xs-12">
      <UsuarioList :colunaNuvem="true" :buttonNovo="false" />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import UsuarioList from "../../../../_shared/features/UsuarioList.vue";

export default {
  name: "UsuariosAdmin",
  components: { UsuarioList },
  data() {
    return {};
  },
  methods: {},
};
</script>
